import { render, staticRenderFns } from "./TimberCategoryForm.vue?vue&type=template&id=9ff99706&"
import script from "./TimberCategoryForm.vue?vue&type=script&lang=js&"
export * from "./TimberCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports